import { useEffect, useState } from 'react';
import { Socket } from 'phoenix';

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:4000/api';
const SOCKET_URL = API_URL.replace(/\/api\/?$/, '') + '/public-socket';

type PresencePayload = {
  online: boolean;
  last_seen_at: string | null;
};

let sharedSocket: Socket | null = null;
let visibilitySubscribed = false;

const subscribeVisibility = () => {
  if (visibilitySubscribed || typeof document === 'undefined') return;
  visibilitySubscribed = true;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible' || !sharedSocket) return;
    if (sharedSocket.isConnected()) return;
    sharedSocket.disconnect(() => sharedSocket?.connect());
  });
};

const getSocket = (): Socket => {
  if (sharedSocket) return sharedSocket;
  sharedSocket = new Socket(SOCKET_URL, {
    heartbeatIntervalMs: 3_000,
  });
  sharedSocket.connect();
  subscribeVisibility();
  return sharedSocket;
};

export const usePublicPresence = (
  profileToken: string | null | undefined,
): PresencePayload | null => {
  const [state, setState] = useState<PresencePayload | null>(null);

  useEffect(() => {
    if (!profileToken) return;

    const socket = getSocket();
    const topic = `presence:profile:${profileToken}`;
    console.log('[usePublicPresence] joining', topic);
    const channel = socket.channel(topic, {});

    channel.on('presence_update', (payload: PresencePayload) => {
      console.log('[usePublicPresence] received presence_update', payload);
      setState({
        online: !!payload.online,
        last_seen_at: payload.last_seen_at ?? null,
      });
    });

    channel
      .join()
      .receive('ok', () => console.log('[usePublicPresence] join ok', topic))
      .receive('error', (err) =>
        console.warn('[usePublicPresence] join error', topic, err),
      );

    return () => {
      console.log('[usePublicPresence] leaving', topic);
      channel.leave();
    };
  }, [profileToken]);

  return state;
};
